import _ from "underscore";
import Constants from "const/constants";

import BaseCollection from "./base";
import StreamModel from "../model/stream";

var StreamCollection = BaseCollection.extend({
    url: function () {
        var params = {
            pageSize: 1000
        };

        if (!_.isUndefined(this.userId)) {
            params.userId = this.userId;
        }

        if (!_.isUndefined(this.extended)) {
            params.extended = this.extended;
        }

        return `${Constants.DEFAULT_API_PATH}/streams?${$.param(params)}`;
    },

    parse: function (res) {
        return res.data;
    },

    constructor: function (attrs, options) {
        attrs = attrs.filter(function (stream) {
            return stream.tempIsHidden === true ? false : true;
        });

        BaseCollection.call(this, attrs, options);
    },

    initialize: function (models, options) {
        options = _.isObject(options) ? options : {};

        if (!_.isUndefined(options.organizationId)) {
            this.organizationId = options.organizationId;
        }
        if (!_.isUndefined(options.userId)) {
            this.userId = options.userId;
        }
        if (!_.isUndefined(options.extended)) {
            this.extended = options.extended;
        }
        this.displayStreamSettingsButton = true;
        if (options.displayStreamSettingsButton === false) {
            this.displayStreamSettingsButton = false;
        }
    },

    model: StreamModel,

    comparator: function (a, b) {
        // return a.getDisplayName() > b.getDisplayName() ? 1 : -1;
        return `${a.getDisplayName()}`.localeCompare(b.getDisplayName());
    },

    search: function (query) {
        return StreamCollection.__super__.search.call(
            this,
            `displayName`,
            query
        );
    },

    pluckDisplayNames: function () {
        var displayNames = [];
        this.each(function (model) {
            displayNames.push(model.getDisplayName());
        });
        return displayNames;
    },

    getCloudproducerEnabledStreams: function () {
        return this.filter(function (stream) {
            return stream.isCloudProducerEnabled();
        });
    }
});

export default StreamCollection;
